import { render, staticRenderFns } from "./CaregiverBehaviorItem.vue?vue&type=template&id=5d097aad&scoped=true"
import script from "./CaregiverBehaviorItem.vue?vue&type=script&lang=js"
export * from "./CaregiverBehaviorItem.vue?vue&type=script&lang=js"
import style0 from "./CaregiverBehaviorItem.vue?vue&type=style&index=0&id=5d097aad&prod&lang=scss"
import style1 from "./CaregiverBehaviorItem.vue?vue&type=style&index=1&id=5d097aad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d097aad",
  null
  
)

export default component.exports